const updatePriority = (priority) => {
  if (process.env.NODE_ENV === 'development') {
    console.info('Skipping updatePriority in development mode')
    return
  }

  if (typeof window !== 'undefined' && window.mapiUtils.updateRequestPriority) {
    try {
      window.mapiUtils.updateRequestPriority(priority)
    } catch (error) {
      console.error('Error updating request priority:', error)
    }
  }
}

export default updatePriority
